module.exports = __webpack_public_path__ + "img/fd57780.png";